import initializeGuidsForSearchStore from '../actions/initializeGuidsForSearchStore';
import SearchStore from '../store/schema/SearchStore';
import { getGuid } from 'owa-guid';
import { getStore as getSearchStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator which initialises the search store guid properties
 * If you need to initialise another guid property in the store please add that here
 * This uses getGuid util
 */
export default mutator(
    initializeGuidsForSearchStore,
    function initializeGuidsForSearchStoreMutator(actionMessage: {}) {
        const searchStore: SearchStore = getSearchStore();
        searchStore.searchSessionGuid = getGuid();
        searchStore.conversationGuid = getGuid();
    }
);
